module.exports = __webpack_public_path__ + "img/prop-trading-step-banner.0688fa91.png";